// extracted by mini-css-extract-plugin
export default {"main":"mainMenu_main__YRrAy","main_hide":"mainMenu_main_hide__FUhqw"};